<template>
  <div>
    <template v-if="imageurl">
    <div v-if="fileSuffix == 'pdf'" @click="onDocumentIcon" class="image-block document-icon"><i class="el-icon-document"></i></div>
    <el-image v-else class="image-block" :preview-src-list="previewList" :src="imageurl"></el-image>
    </template>
    <input v-show="false" ref="ff" type="file" @change="onUplpad" />
    <el-input :disabled="true" placeholder="" v-model="input2">
         <el-button :disabled="disabled" slot="append" icon="el-icon-folder-opened" class="themeButton" @click="onSelectImageButton"
            >瀏覽</el-button>
    </el-input>
  </div>
</template>

<script>
import {getFileName,getFileSuffix,openFile} from "@/utils/is-rules";
import { file } from "@/api/parent/files";
export default {
  props: {
    imageurl: {
      type: String,
      default: "",
    },
    uploadUrl: {
      type: String,
      default: "/files",
    },
    buttonText: {
      type: String,
      default: "Select Image",
    },
    fileType: {
      type: Array,
       default() {
        return ['pdf', 'doc', 'xlsx', 'png', 'jpg', 'txt', 'docx', 'jpeg', 'tiff', 'raw', 'gif', 'ppt', 'pptx', 'mp4', 'mp3', 'mov', 'wmv']
      }
    },
    isImgDom:{
      type:Boolean,
      default: true
    },
    disabled:{
      type:Boolean,
      default: false
    },
    fileSize:{
      type:Number,
      default:50
    }
  },
  data() {
    return {
      fileSuffix:"",
      width: 1024,
      height: 600,
      input2:'',
      previewList:[this.imageurl]
    }
  },
  watch:{
    imageurl:{
      handler(v){
        if(v!=''&& v!=null){
          this.previewList[0]=v
          this.input2 = this.getFileName(v)
          this.getFileSuffix()
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods: {
    onSelectImageButton() {
      this.$refs.ff.click();
    },
    onUplpad(e) {  
      if (e.target.files[0].type != null) {
        const that = this
        var fileSize = e.target.files[0].size
        var size = fileSize / 1024
        const isFileType = that.fileType.includes(
          e.target.files[0].name.split('.').pop()
        )
        if (!isFileType) {
          that.$message.error('The file format is incorrect')
          return false
        }
        if(size > that.fileSize * 1000){
            that.$message.error(`up to ${that.fileSize}MB`)
            return false
        }
        this.uploadFormData(e)
      }
    },
    async isSize(file){
          let _URL = window.URL || window.webkitURL;
          let imgDom  = new Image();
          let width = this.width;
          let height = this.height;
          let imgfile = _URL.createObjectURL(file.target.files[0])
          imgDom.src = imgfile;
          new Promise(function (resolve, reject){
            imgDom.onload =  () =>  {
              let isSize = imgDom.width == width && imgDom.height == height
              isSize ? resolve() : reject();  
            }
          }).then(()=>{
            this.uploadFormData(file)
          }).catch(()=>{
             this.$message.error(`上传文件的图片大小不合符标準,宽需要为'${this.width}'px，高需要为' ${this.height}'px。`)
          })
          
          
    },
    uploadFormData(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      file(this.uploadUrl,formData)
        .then((v) => {
          this.$emit("childByValue", v.data);
          this.input2 = this.getImagesName(v.data) 
          this.$message({
            type: "success",
            message: "上傳成功!",
          });
        }).finally(()=>{
           this.$refs.ff.value = null
        })
    },
    onDocumentIcon(){
      this.openFile()
    },
    openFile(){
      openFile(this.imageurl)
    },
    getFileSuffix(){
      this.fileSuffix = getFileSuffix(this.imageurl)
    },
    getFileName(v){
     return getFileName(v)
    },
    getImagesName(file){
      let imagesName = file.split('/')
      return imagesName[imagesName.length-1]

    }
  },
};
</script>

<style lang="scss" scoped>
.themeButton {
  color: #fff!important;
  background-color: #72ACFF !important;
}
.image-block{
  display: block;
  margin-bottom: 10px;
  width: 100px;
  height: 100px;
  border: 1px solid #72ACFF;
  padding: 8px;
}
.document-icon{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  color: #72ACFF;
  //手形
  cursor: pointer;
}
::v-deep{
  .el-input__inner{
  border-color: #72ACFF !important;
  border-width: 2px;
  }
}

</style>